import React, {Component} from 'react'
import {Alert, Button, Spin} from 'antd'
import harnessAPI from '../../apis/harnessAPI'
import auth from '../../utils/auth'

class Harness extends Component {
  state = {loading: true, url: '', error: ''}

  iframeRef = React.createRef()

  componentDidMount() {
    window.addEventListener('message', this.onHarnessMessage)
    this.load()
  }

  componentWillUnmount() {
    this.unmounted = true
    window.removeEventListener('message', this.onHarnessMessage)
  }

  load = () => {
    if (!auth.getToken()) {
      this.setState({loading: false, error: '未获取到 Anylink 登录凭证，Harness 不会发起请求'})
      return
    }
    this.setState({loading: true, error: ''})
    harnessAPI.runtimeEntry()
      .then(response => {
        const entry = response?.data?.data?.url
        if (!entry) throw new Error(response?.data?.message || 'Harness Web 地址未配置')
        return harnessAPI.bootstrapEmbed().then(() => ({entry}))
      })
      .then(({entry}) => {
        const target = new URL(entry, window.location.href)
        // The bootstrap endpoint is an auth exchange and intentionally returns
        // 204; it is not a document. Keep the iframe on the real Harness root.
        // The embedded enterprise plugin receives the parent token after load,
        // then fetches the exchange endpoint with iframe credentials itself.
        this.iframeOrigin = target.origin
        if (!this.unmounted) this.setState({loading: false, url: target.href, error: ''})
      })
      .catch(error => {
        if (!this.unmounted) this.setState({loading: false, error: error?.message || String(error)})
      })
  }

  sendAuth = () => {
    const token = auth.getToken()
    const frame = this.iframeRef.current
    if (!token || !frame || !this.iframeOrigin) return
    frame.contentWindow.postMessage({type: 'isp-harness-auth', token}, this.iframeOrigin)
  }

  onHarnessLoad = () => {
    this.sendAuth()
  }

  onHarnessMessage = event => {
    const frame = this.iframeRef.current
    if (!frame || event.source !== frame.contentWindow || event.origin !== this.iframeOrigin) return
    const message = event.data
    if (!message || typeof message !== 'object') return
    if (message.type === 'isp-harness-auth-request') {
      this.sendAuth()
      return
    }
    if (message.type === 'isp-harness-auth-status' && message.status === 'invalid') {
      this.setState({error: message.message || 'Anylink 登录已失效，请重新登录'})
    }
  }

  render() {
    const {loading, url, error} = this.state
    if (loading) return <Spin style={{position: 'absolute', top: '50%', left: '50%'}} size="large"/>
    if (error) return <Alert type="error" showIcon message={error}
      action={<Button size="small" onClick={this.load}>重新连接</Button>}/>
    return <iframe
      title="DeepSeek Harness"
      src={url}
      ref={this.iframeRef}
      onLoad={this.onHarnessLoad}
      referrerPolicy="no-referrer"
      allow="clipboard-read; clipboard-write"
      style={{display: 'block', width: '100%', height: 'calc(100vh - 120px)', minHeight: 620, border: 0, background: '#fff'}}
    />
  }
}

export default Harness
